import $ from 'jquery';

import BaseController from 'chairisher/_controller';

import executeRecaptcha from 'chairisher/view/helper/recaptcha';

import { getRecaptchaActionsObject } from 'chairisher/context/auth';

/**
 * Controller that binds actions for the Privacy Request page
 */
class PrivacyRequest extends BaseController {
    bindPageActions() {
        const $form = $('#js-privacy-request-form');
        const $submitButton = $form.find('button[type="submit"]');

        $form.on('submit', (e) => {
            e.preventDefault();
            $submitButton.prop('disabled', true);

            executeRecaptcha(getRecaptchaActionsObject().PRIVACY_REQUEST).then(
                () => {
                    $form.get(0).submit();
                },
                () => {
                    $submitButton.prop('disabled', false);
                },
            );
        });
    }
}

export default PrivacyRequest;
